module.exports = __webpack_public_path__ + "static/img/jianting.dc7c033.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/jianting.png
// module id = Xnu9
// module chunks = 24